export default {
  title: 'Preparando o Editor de Sites',
  subtitle: 'Espere um momento que estamos preparando tudo para você!',
  error: 'Tivemos um problema ao processar a solicitação, tente novamente!'
}
